export function test() {
  console.log('test');
}

// 简易节流
export function throttle(func, wait) {
  let lastTime;
  return function (...rest) {
    if (!lastTime
            || (new Date().getTime() - lastTime > wait)) {
      lastTime = +new Date();
      func.apply(this, rest);
    }
  };
}
